import { ca } from '@cian/analytics';

interface ITrackPinClickParameters {
  isDetailsVisible: boolean;
  zoom: number;
}

export function trackPinClick({ zoom }: ITrackPinClickParameters) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_pin',
    category: 'Map',
    label: `blue/${zoom}`,
    page: {
      queryString: window.location.search,
    },
  });
}
